import { DRAFT_STEPS, type DraftStep } from "../types/esign.types.ts"

/**
 * Document → Recipients → Signature fields → Review & send.
 *
 * The same four words the server stores in `draft_step`, so resuming a saved
 * draft needs no mapping between what the sender saw and what was recorded.
 * Choosing the document used to sit outside the numbered steps, in the address
 * bar; it is a step like the others now, which is what lets Save & exit work
 * from the very beginning.
 */
export const WIZARD_STEPS = DRAFT_STEPS

export type WizardStep = DraftStep

export const asWizardStep = (value: string | null): WizardStep =>
  (WIZARD_STEPS as readonly string[]).includes(value ?? "")
    ? (value as WizardStep)
    : "document"

export const stepNumber = (step: WizardStep) => WIZARD_STEPS.indexOf(step) + 1

export const stepBefore = (step: WizardStep): WizardStep | null =>
  WIZARD_STEPS[WIZARD_STEPS.indexOf(step) - 1] ?? null

export const stepAfter = (step: WizardStep): WizardStep | null =>
  WIZARD_STEPS[WIZARD_STEPS.indexOf(step) + 1] ?? null

/** Where a saved draft reopens: the step it was left on, or the first one. */
export const resumeStep = (saved: DraftStep | "" | undefined): WizardStep =>
  asWizardStep(saved || null)
